module.exports = __webpack_public_path__ + "img/product_77.67a5198.webp";